export { default } from './SearchForm';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentSearch/SearchForm/index.js